import axios from "axios";
export default {
    namespaced: true,
    state: {
        token: null,
        shipment: null,
        selected: null,
        currentProcess: null,
    },
    getters: {
        shipment: (state) => state.shipment,
        shipmentStatus: (state) => state.shipment.shipmentStatus,
        shipmentStatusBar: (state) => state.shipment.statusBar,
        shipmentCurrentStepNumber: (state) => state.shipment.statusBar.currentStepNumber,
        currentStep: (state) => state.shipment.statusBar.steps.find(step => step.stepNumber == state.shipment.statusBar.currentStepNumber),
        token: (state) => state.token,
        selected: (state) => state.selected,
        currentProcess: (state) => state.currentProcess,
        nextRoute: (state) => state.nextRoute,
    },
    mutations: {
        APP_LOAD: (state, o) => {
            state.shipment = o.shipment;
            state.token = o.token;
        },
        CLEAR_STATE: (state) => {
            state.shipment = null;
            state.token = null;
        },
        SET_SELECTED: (state, point) => {
            state.selected = point;
        },
        SET_CURRENT_PROCESS: (state, p) =>{
            state.currentProcess = p;
        },
        SET_SMS_CODE: (state, p) => {
            state.smsCode = p;
        },
        SET_NEXT_ROUTE: (state, p) => {
            state.nextRoute = p;
        }
    },
    actions: {
        clearState: ({commit}) => {
            commit("CLEAR_STATE");
        },
        loadShipment: ({ commit }, token) => {
            return new Promise((resolve, reject) => {
                if(!token) { 
                    reject('Token bulunamadı!!!');
                    return;
                }
                axios.post("/api/v1/idelivery/shipment", null, {
                    headers: {
                        'X-YK-SHIPMENT-TOKEN': token
                    }
                }).then((res) => {
                    commit("APP_LOAD", { shipment: res.data.resultCode !== 1 ? res.data : null, token: token });
                    resolve(res);
                }).catch((error) => {
                    reject(error);
                });

            });
        },
        setSelected({ commit }, point) {
            commit('SET_SELECTED', point);
        },
        setCurrentProcess({ commit }, process) {
            commit('SET_CURRENT_PROCESS', process);
        },
    },
};
